import CollapseFilter from './CollapseFilter.jsx';

export {
  CollapseFilter
}


// WEBPACK FOOTER //
// ./components/partials/collapse/index.js